// extracted by mini-css-extract-plugin
module.exports = {"btnLink":"index_btnLink__1SZAS","lineHeight28":"index_lineHeight28___ZPtF"};